import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../default-cloud-graph-work-item-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgePioGuruIcon } from './icon';
import { ForgePioGuruSearchResultIcon } from './search-result-icon';

export const forgePioGuruConfig: ThirdPartyConfig = {
	displayName: 'Guru by Pio',
	id: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
	resourceType: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
	icon: get3PLogo(ForgePioGuruIcon, 'ForgePioGuru', 'medium'),
	searchResultIcon: get3PLogo(ForgePioGuruSearchResultIcon, 'ForgePioGuru', 'large'),
	integrationAri: 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
